import { httpCreate } from './http';

const http = httpCreate('/srv/copyTask');

export const copyTask = {
	// 复制任务列表 photolive 直播 0，云摄影：1
	getCopyTask(photoLive = 0) {
		return http.get(`/get?photoLive=${photoLive}`);
	},
	// 取消任务
	cancelTask(taskId) {
		return http.put(`/cancel/${taskId}`);
	},
	// 创建/重试直播间复制任务 云摄影
	photoCopy(activityId) {
		return http.post(`/copy/${activityId}`);
	},
};
